import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import PublicList from "../Spots/Tabs/PublicList";
import PrivateList from "../Spots/Tabs/PrivateList";

const Spots = () => {
  const { t } = useTranslation();
  const [key, setKey] = useState("public");

  return (
    <div className="UserDiv">
      <div>
        <p className="UserTabHeading">{t("spots")}</p>

        <div className="tabsDiv ">
          <div>
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className=""
            >
              <Tab eventKey="public" title={t("public")}>
                {key === "public" && <PublicList />}
              </Tab>
              <Tab eventKey="private" title={t("private")}>
                {key === "private" && <PrivateList />}
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spots;
